/// <reference path="index.d.ts" />
import * as React from 'react';
import { Slider,Balloon,Icon } from '@alifd/next';
import ImageDrag from './image-drag';

const { Fragment } = React;

interface PropsInterface {
  mediaItems: [ImageInterface];
  imageZoom: ZoomProps
  handleChange: ( index: number ) => void;
  activedId: number;
}

function SliderImage ( props: PropsInterface ) {
  const { mediaItems,handleChange,activedId,imageZoom } = props;

  const renderImage = ( item: ImageInterface,index: number ) => {
    const { item: other } = item;
    const { AsyncVideoPlay } = window as any;
    // 视频直接拷贝
    if ( other.type === 'video' && AsyncVideoPlay ) {
      return <AsyncVideoPlay {...other} videoWidth={480} videoHeight={480} />
    }

    // 产品证书
    if ( other.verifiedLogoUrl || other.bizType === 'Certification' ) {
      return <Fragment>
        <Balloon
          trigger={<img className="cetificate-image" src="//s.alicdn.com/@img/imgextra/i2/O1CN01DhLkm71bM95HK5hkt_!!6000000003450-2-tps-234-54.png" />}
          align="bl" alignEdge triggerType="hover" style={{ width: 300 }} closable={false}>
          <span dangerouslySetInnerHTML={{
            __html: other.disclaimer
          }}></span>
        </Balloon>
        <ImageDrag url={item.url} imageZoom={activedId === index ? imageZoom : null} />
        <div className="cetificate-bottom">
          <Balloon trigger={<h3>{other.certName}<Icon type="prompt" size="xs" /></h3>} align="tr" closable={false} triggerType="hover" style={{ width: 300 }}>
            {other.introduction}
          </Balloon>
          <div>
            {other.description}
          </div>
        </div>
      </Fragment>;
    }

    return <ImageDrag url={item.url} imageZoom={activedId === index ? imageZoom : null} />;
  };

  return (
    <Slider infinite={false} className="slider-image" draggable={false} defaultActiveIndex={activedId} dots={false} onChange={handleChange}>
      {mediaItems.map( ( item: ImageInterface,index: number ) => <div key={index} className="slider-img-wrapper">{renderImage( item,index )}</div> )}
    </Slider>
  );
}

export default SliderImage;
